<!-- Status Display Template -->
<ng-template #statusTemplate let-status="status">
  <div
    class="flex items-center gap-2 rounded-md bg-green-50 px-3 py-1.5 text-sm"
  >
    <mat-icon class="text-green-500"> check_circle </mat-icon>
    <span class="font-medium text-green-500">
      {{ status.feedback }}
    </span>
    <span class="text-green-500">
      {{ status.actionTime | moment | amDateFormat: dateFormat }}
    </span>
  </div>
</ng-template>

@if (form(); as formGroup) {
  <form class="flex w-full flex-col gap-8" [formGroup]="formGroup">
    <div>
      <h2 class="!font-medium">Send Forms To Patient</h2>

      <pr-information-box>
        You can optionally send the Patient Details, Accident Details, and
        Employment Details forms to the patient to fill out.
      </pr-information-box>

      <div class="my-4 flex flex-col space-y-2" [formGroup]="selectedForms">
        <div class="mb-2 text-sm font-medium text-slate-700">
          Select forms to send:
        </div>

        <div class="flex items-center gap-4">
          <mat-checkbox
            [formControlName]="accPatientForm.AccPatientDetailsForm"
          >
            Patient Details
          </mat-checkbox>
          @if (
            patientFormStatus()[accPatientForm.AccPatientDetailsForm];
            as status
          ) {
            <ng-container
              *ngTemplateOutlet="statusTemplate; context: { status: status }"
            />
          }
        </div>

        <div class="flex items-center gap-4">
          <mat-checkbox
            [formControlName]="accPatientForm.AccAccidentDetailsForm"
          >
            Accident Details
          </mat-checkbox>
          @if (
            patientFormStatus()[accPatientForm.AccAccidentDetailsForm];
            as status
          ) {
            <ng-container
              *ngTemplateOutlet="statusTemplate; context: { status: status }"
            />
          }
        </div>

        <div class="flex items-center gap-4">
          <mat-checkbox
            [formControlName]="accPatientForm.AccEmploymentDetailsForm"
          >
            Employment Details
          </mat-checkbox>
          @if (
            patientFormStatus()[accPatientForm.AccEmploymentDetailsForm];
            as status
          ) {
            <ng-container
              *ngTemplateOutlet="statusTemplate; context: { status: status }"
            />
          }
        </div>
      </div>

      <div class="mb-4 flex gap-3">
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="flex items-center gap-2"
          [disabled]="disableNotificationButton()"
          (click)="sendAsEmail()"
        >
          <mat-icon>email</mat-icon>
          Send via Email
        </button>

        <button
          mat-flat-button
          color="accent"
          type="button"
          class="flex items-center gap-2"
          [disabled]="disableNotificationButton()"
          (click)="sendAsSMS()"
        >
          <mat-icon>sms</mat-icon>
          Send via SMS
        </button>
      </div>
    </div>

    <div>
      <h2 class="!font-medium">Claim Number</h2>

      <mat-form-field class="mb-4 w-full">
        <mat-label>Claim Number</mat-label>
        <input matInput formControlName="claimNumber" />
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <pr-information-box>
        If you are using a paper claim form, please enter the claim number at
        the top right-hand corner of the form. Otherwise one will be generated
        for you.
      </pr-information-box>
    </div>

    <div>
      <h2 class="!font-medium">Provider</h2>

      <mat-form-field class="mb-4 w-full">
        <mat-label>Select a provider</mat-label>
        <mat-select [formControl]="providerCtrl" [compareWith]="compareFn">
          <mat-select-trigger>
            <span>
              {{ providerCtrl.value?.firstName }}
              {{ providerCtrl.value?.surname }}
            </span>
          </mat-select-trigger>
          @for (providerGroup of providerOptions(); track providerGroup.group) {
            <mat-optgroup class="!font-bold" [label]="providerGroup.group">
              @for (option of providerGroup.options; track option.providerId) {
                <mat-option [value]="option">
                  <div class="flex w-full items-center gap-4">
                    <span>{{ option.firstName }} {{ option.surname }}</span>
                    <span class="text-slate-500">{{ option.providerId }}</span>
                  </div>
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
        @if (providerCtrl.invalid && providerCtrl.touched) {
          <mat-error>Provider is required</mat-error>
        }
      </mat-form-field>

      <pr-information-box>
        Select the treatment provider that examined the patient and is providing
        the data for this claim.
      </pr-information-box>
    </div>
  </form>
}
